import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Header */}
      <section className="pad-2xl">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="heading-1 mb-6">Terms of Service</h1>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pad-lg">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {/* Introduction */}
              <div>
                <h2 className="heading-2 mb-4">1. Agreement to Terms</h2>
                <p className="body-medium mb-4">
                  By accessing and using AutomationFirst's website (automation1st.com) and services, you agree to be bound by these Terms of Service. 
                  If you do not agree to these terms, please do not use our services.
                </p>
              </div>

              {/* Services Description */}
              <div>
                <h2 className="heading-2 mb-4">2. Description of Services</h2>
                <p className="body-medium mb-4">
                  AutomationFirst provides business automation consulting services, including:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Workflow automation analysis and recommendations</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Business process optimisation</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Automation implementation and support</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Free business automation audits</span>
                  </li>
                </ul>
              </div>

              {/* User Responsibilities */}
              <div>
                <h2 className="heading-2 mb-4">3. User Responsibilities</h2>
                <p className="body-medium mb-3">By using our services, you agree to:</p>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Provide accurate and truthful information</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Use our services only for lawful purposes</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Respect our intellectual property rights</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Not attempt to unauthorised access to our systems</span>
                  </li>
                </ul>
              </div>

              {/* Intellectual Property */}
              <div>
                <h2 className="heading-2 mb-4">4. Intellectual Property</h2>
                <p className="body-medium mb-4">
                  All content, trademarks, and intellectual property on our website and in our services remain the property of AutomationFirst. 
                  You may not reproduce, distribute, or create derivative works without our express written permission.
                </p>
              </div>

              {/* Service Availability */}
              <div>
                <h2 className="heading-2 mb-4">5. Service Availability</h2>
                <p className="body-medium mb-4">
                  We strive to maintain continuous service availability but cannot guarantee uninterrupted access. 
                  We reserve the right to modify, suspend, or discontinue any part of our services with reasonable notice.
                </p>
              </div>

              {/* Payment Terms */}
              <div>
                <h2 className="heading-2 mb-4">6. Payment Terms</h2>
                <ul className="space-y-2">
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Free audit services are provided at no cost</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Paid services require advance payment or as agreed in writing</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>All prices are in Indian Rupees (INR) unless otherwise stated</span>
                  </li>
                  <li className="flex items-start body-medium">
                    <span className="mr-2">•</span>
                    <span>Refunds are subject to our refund policy</span>
                  </li>
                </ul>
              </div>

              {/* Limitation of Liability */}
              <div>
                <h2 className="heading-2 mb-4">7. Limitation of Liability</h2>
                <p className="body-medium mb-4">
                  To the maximum extent permitted by law, AutomationFirst shall not be liable for any indirect, 
                  incidental, special, or consequential damages arising from your use of our services. 
                  Our total liability shall not exceed the amount paid for our services.
                </p>
              </div>

              {/* Disclaimer */}
              <div>
                <h2 className="heading-2 mb-4">8. Disclaimer</h2>
                <p className="body-medium mb-4">
                  Our services are provided "as is" without any warranties, express or implied. 
                  While we strive to provide accurate recommendations, results may vary based on implementation and business factors.
                </p>
              </div>

              {/* Privacy */}
              <div>
                <h2 className="heading-2 mb-4">9. Privacy</h2>
                <p className="body-medium mb-4">
                  Your privacy is important to us. Please review our <Link to="/privacy-policy" className="link-text">Privacy Policy</Link> to 
                  understand how we collect, use, and protect your personal information.
                </p>
              </div>

              {/* Governing Law */}
              <div>
                <h2 className="heading-2 mb-4">10. Governing Law</h2>
                <p className="body-medium mb-4">
                  These Terms of Service are governed by the laws of India. Any disputes will be resolved in the courts of Mumbai, India.
                </p>
              </div>

              {/* Changes to Terms */}
              <div>
                <h2 className="heading-2 mb-4">11. Changes to Terms</h2>
                <p className="body-medium mb-4">
                  We reserve the right to modify these terms at any time. We will notify users of significant changes via 
                  email or prominent website notice. Continued use of our services constitutes acceptance of modified terms.
                </p>
              </div>

              {/* Contact Information */}
              <div>
                <h2 className="heading-2 mb-4">12. Contact Information</h2>
                <p className="body-medium mb-4">
                  If you have any questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="body-medium mb-2">
                    <strong>Email:</strong> hello@automation1st.com
                  </p>
                  <p className="body-medium mb-2">
                    <strong>Phone:</strong> +91 9324280636
                  </p>
                  <p className="body-medium">
                    <strong>Address:</strong> Mumbai, India
                  </p>
                </div>
              </div>
            </div>

            {/* Back to Home */}
            <div className="mt-12 text-center">
              <Link to="/" className="btn-secondary">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;